import { MultiEmailInputV2, CustomButton, CustomInput } from '@/shared/ui/components';
import _ from 'lodash';
import { t } from 'ttag';
import { useOther } from './useOther';
import SEND_REQUEST from '../submitARequest.constants';
import type { OtherProps } from './other.types';
import './styles.scss';

/**
 * Form for the Other category of support request, taking a free-text message and notification recipients. Wires message, email list and input state from useOther, renders a textarea and a MultiEmailInputV2 that surfaces invalid email errors, and disables the send button until a message and at least one email or pending input exist, submitting through a short setTimeout around onClickSendMessage.
 *
 * @param category - Support request category submitted with the message.
 * @param selectedFacility - Facility the request is raised for.
 * @param setLoadingPage - Setter toggling the page-level loading overlay.
 * @param backToPrevious - Callback returning to the previous support request screen.
 * @returns Other-category support request form element.
 */
const Other = ({ category, selectedFacility, setLoadingPage, backToPrevious }: OtherProps) => {
  const { state, onChange, onClickSendMessage, onChangeEmailList, onInputChange } = useOther({
    category,
    selectedFacility,
    setLoadingPage,
    backToPrevious,
  });

  return (
    <div className="other-tab">
      <div className="message-box">
        <span className="big-title">Message</span>
        <CustomInput
          className="message-text"
          placeholder={t`Enter your message`}
          type="textarea"
          value={state.message}
          onChange={onChange}
          name="message"
          allowClear={false}
        />
      </div>

      <div className="email-box">
        <span className="big-title">{t`Notification email`}</span>
        <MultiEmailInputV2
          emailList={state.emailList}
          emailInputValue={state.emailInputValue}
          onChangeEmailList={onChangeEmailList}
          onInputChange={onInputChange}
          isError={!_.isEmpty(state.errorObject.invalidEmails)}
          errorMessage={state.errorObject.invalidEmails}
        />
      </div>

      <div className="bottom-button-row">
        <CustomButton
          id="submit-btn"
          className="button-submit"
          disabled={
            (_.isEmpty(state.emailList) && !state.emailInputValue) ||
            !state.message ||
            state.isSaving
          }
          // loading={state.isSaving}
          onClick={() => setTimeout(onClickSendMessage, 100)}
        >
          {SEND_REQUEST}
        </CustomButton>
      </div>
    </div>
  );
};

export default Other;
